import api from '../../api'

export default {
  namespaced: true,
  state: {
    comments: {
      comments: [],
      statistic: null,
      comments_left: null,
      offset: null,
      total_count: null
    },
    tags: [],
    commentsWithMedia: {},
    currentMediaIndex: 0,
    isLoading: false
  },
  mutations: {
    SET_TAGS: (state, data) => {
      state.tags = data
    },
    SET_COMMENTS: (state, obj) => {
      state.comments.comments = [ ...state.comments.comments, ...obj.comments ]
      state.comments.statistic = obj.statistic ?? null
      state.comments.comments_left = obj.comments_left
      state.comments.offset = obj.offset
      state.comments.total_count = obj.total_count
    },
    SET_COMMENTS_WITH_MEDIA: (state, obj) => {
      state.commentsWithMedia = obj
    },
    SET_CURRENT_MEDIA_INDEX: (state, index) => {
      state.currentMediaIndex = index
    },
    SET_IS_LOADING: (state, bool) => {
      state.isLoading = bool
    }
  },
  actions: {
    FETCH_TAGS: ({ commit, rootGetters }, payload) => {
      return new Promise((resolve, reject) => {
        commit('SET_IS_LOADING', true)
        api.questions.getTags(payload)
          .then(res => {
            commit('SET_TAGS', res)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_IS_LOADING', false)
          })
      })
    },
    FETCH_QUESTIONS: ({ commit, rootGetters }, payload) => {
      return new Promise((resolve, reject) => {
        commit('SET_IS_LOADING', true)

        api.questions.getQuestions(payload)
          .then(res => {
            if (res.success) {
              payload.onlyWithMedia ? commit('SET_COMMENTS_WITH_MEDIA', res) : commit('SET_COMMENTS', res)
            }
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_IS_LOADING', false)
          })
      })
    },
    CHANGE_CURRENT_MEDIA_QUESTIONS_INDEX: ({ commit }, index) => {
      commit('SET_CURRENT_MEDIA_INDEX', index)
    },
    POST_NEW_QUESTION: ({ commit, rootGetters }, payload) => {
      return new Promise((resolve, reject) => {
        api.questions.postQuestion(payload)
          .then(res => {
            if (res.success) {
              resolve({ success: true, message: rootGetters.translations('questions.result_success_msg') })
            } else {
              resolve({ success: false, message: rootGetters.translations('questions.result_error_msg') })
            }
          })
          .catch(() => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({ success: false, message: rootGetters.translations('questions.result_error_msg') })
          })
      })
    }
  }
}
